/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * First line of the billing address
     * @type {string}
     * @memberof Address
     */
    line1: string;
    /**
     * Second line of the billing address
     * @type {string}
     * @memberof Address
     */
    line2: string;
    /**
     * Postal code
     * @type {string}
     * @memberof Address
     */
    postalCode: string;
    /**
     * City
     * @type {string}
     * @memberof Address
     */
    city: string;
    /**
     * State or province
     * @type {string}
     * @memberof Address
     */
    state: string;
    /**
     * Two-letter ISO country code
     * @type {string}
     * @memberof Address
     */
    country: string;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('line2' in value) || value['line2'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'],
        'line2': json['line2'],
        'postalCode': json['postalCode'],
        'city': json['city'],
        'state': json['state'],
        'country': json['country'],
    };
}

export function AddressToJSON(json: any): Address {
    return AddressToJSONTyped(json, false);
}

export function AddressToJSONTyped(value?: Address | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'state': value['state'],
        'country': value['country'],
    };
}

